module.exports = __webpack_public_path__ + "static/media/truck1500.879b4f04.svg";